import React from "react";
import { Navigate } from "react-router-dom";

import { getActiveQuizId } from "../helpers/dataHelpers";

const withCheckForActiveCategory =
  (WrappedComponent) =>
  ({ ...props }) =>
    (
      <>
        {!getActiveQuizId() ? (
          <Navigate replace="true" to={`/`} />
        ) : (
          <WrappedComponent {...props} />
        )}
      </>
    );

export default withCheckForActiveCategory;
